import { memo, ReactElement, ReactNode, useCallback, useContext, useId } from "react";
import classNames from "classnames";
import { NavbarContext, OpenDrop } from "../../Navbar/NavbarContext/NavbarContext";

import styles from "../style.module.scss";

type MenuItemProps = {
  children?: ReactElement,
  component?: ReactNode,
  setOpen: (value: OpenDrop | undefined) => void,
  setIsFade: (value: boolean) => void,
}

export const MenuItemExotic = memo<MenuItemProps>((
  {
    component,
    setOpen,
    setIsFade,
    children,
  }) => {

  const id = useId();

  const { isFade, open } = useContext(NavbarContext);

  const dropdownToggle = useCallback(() => {
    if (isFade && !open) {
      setOpen({ id: id, status: true });
    }
    if (!isFade && !open) {
      setOpen({ id: id, status: true });
      setIsFade(true);
    } else {
      setIsFade(false);
      setOpen(undefined);
    }
  }, [ setOpen, setIsFade, isFade, open, id ]);

  const close = useCallback(() => {
    setIsFade(false);
    setOpen(undefined);
  }, [ setIsFade, setOpen ]);

  return (
    <div
      onBlur={close}
      className={classNames(styles.arrow, {
        [styles.dropHead]: open?.id === id,
        [styles.elementArrow]: children?.props?.children?.length && open?.id === id,
      })}
    >
      <div onClick={dropdownToggle}>
        {component}
      </div>
      {children}
    </div>
  );
});
